'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Const enum of arithmatic operators.
 *
 * @export
 * @enum {string}
 */
var ArithmeticOperator = /*#__PURE__*/function (ArithmeticOperator) {
  ArithmeticOperator["Plus"] = "+";
  ArithmeticOperator["Minus"] = "-";
  ArithmeticOperator["Multiply"] = "*";
  ArithmeticOperator["Divide"] = "/";
  ArithmeticOperator["Power"] = "^";
  ArithmeticOperator["Mod"] = "%";
  return ArithmeticOperator;
}({});

/**
 * Const enum of relational operators.
 *
 * @export
 * @enum {string}
 */
var RelationalOperator = /*#__PURE__*/function (RelationalOperator) {
  RelationalOperator["Equal"] = "==";
  RelationalOperator["NotEqual"] = "!=";
  RelationalOperator["Larger"] = ">";
  RelationalOperator["LargerOrEqual"] = ">=";
  RelationalOperator["Smaller"] = "<";
  RelationalOperator["SmallerOrEqual"] = "<=";
  return RelationalOperator;
}({});

/**
 * Const enum of predicate operators.
 *
 * @export
 * @enum {string}
 */
var PredicateOperator = /*#__PURE__*/function (PredicateOperator) {
  PredicateOperator["IsNumeric"] = "IS NUMERIC";
  PredicateOperator["IsEmpty"] = "IS EMPTY";
  PredicateOperator["In"] = "IN";
  PredicateOperator["BetweenAnd"] = "BETWEEN AND";
  PredicateOperator["And"] = "AND";
  PredicateOperator["Or"] = "OR";
  PredicateOperator["Not"] = "NOT";
  return PredicateOperator;
}({});

/**
 * Const enum of functions.
 *
 * @export
 * @enum {string}
 */
var FunctionType = /*#__PURE__*/function (FunctionType) {
  FunctionType["ToFloat"] = "to_float";
  FunctionType["ToInt"] = "to_int";
  FunctionType["ToDatetime"] = "to_datetime";
  FunctionType["Concat"] = "concat";
  FunctionType["TokenLen"] = "token_len";
  FunctionType["Sqrt"] = "sqrt";
  FunctionType["Count"] = "COUNT(*)";
  FunctionType["DistinctCount"] = "DISTINCT COUNT";
  FunctionType["Sum"] = "SUM";
  FunctionType["Min"] = "MIN";
  FunctionType["Max"] = "MAX";
  FunctionType["Avg"] = "AVG";
  FunctionType["Collect"] = "COLLECT";
  FunctionType["DistinctCollect"] = "DISTINCT COLLECT";
  return FunctionType;
}({});

/**
 * Const enum of currently supported functions and operators.
 *
 * @export
 * @enum {string}
 */
var SupportedOperatorAndFunctionTypes = [ArithmeticOperator.Plus, ArithmeticOperator.Minus, ArithmeticOperator.Multiply, ArithmeticOperator.Divide, ArithmeticOperator.Power, ArithmeticOperator.Mod, RelationalOperator.Equal, RelationalOperator.NotEqual, RelationalOperator.Larger, RelationalOperator.LargerOrEqual, RelationalOperator.Smaller, RelationalOperator.SmallerOrEqual, PredicateOperator.IsNumeric, PredicateOperator.IsEmpty, PredicateOperator.In, PredicateOperator.BetweenAnd, PredicateOperator.And, PredicateOperator.Or, PredicateOperator.Not, FunctionType.ToFloat, FunctionType.ToInt, FunctionType.ToDatetime, FunctionType.Concat, FunctionType.TokenLen, FunctionType.Sqrt, FunctionType.Count, FunctionType.DistinctCount, FunctionType.Sum, FunctionType.Min, FunctionType.Max, FunctionType.Avg];

exports.ArithmeticOperator = ArithmeticOperator;
exports.FunctionType = FunctionType;
exports.PredicateOperator = PredicateOperator;
exports.RelationalOperator = RelationalOperator;
exports.SupportedOperatorAndFunctionTypes = SupportedOperatorAndFunctionTypes;
